import React, { PureComponent } from "react";
import { formatNumber, numberWithCommas } from "../utils";
import moment from "moment-timezone";

import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more.js";
import solidGauge from "highcharts/modules/solid-gauge.js";
import HighchartsCustomEvents from "highcharts-custom-events";

highchartsMore(Highcharts);
solidGauge(Highcharts);
HighchartsCustomEvents(Highcharts);
(function (H) {
    H.addEvent(H.Legend, "afterColorizeItem", function (e) {
        if (e.visible && e.item && e.item.userOptions) {
            e.item.legendSymbol?.attr({
                fill: e.item.userOptions.color,
            });
        }
    });
})(Highcharts);

class LeaderboardHealthCharts extends PureComponent {
    state = {};

    colors = [
        ["rgba(219,40,40,1)", "rgba(219,40,40,0.7)", "rgba(219,40,40,0.4)"],
        ["rgba(242, 113, 28,1)", "rgba(242, 113, 28,0.7)", "rgba(242, 113, 28,0.4)"],
        ["rgba(100, 53, 201, 1)", "rgba(100, 53, 201,0.7)", "rgba(100, 53, 201,0.4)"],
        ["rgba(224, 57, 151,1)", "rgba(224, 57, 151,0.7)", "rgba(224, 57, 151,0.4)"],
        ["rgba(163, 51, 200,1)", "rgba(163, 51, 200,0.7)", "rgba(163, 51, 200,0.4)"],
        ["rgba(33, 186, 69,1)", "rgba(33, 186, 69,0.7)", "rgba(33, 186, 69,0.4)"],
        ["rgba(77, 144, 254,1)", "rgba(77, 144, 254,0.7)", "rgba(77, 144, 254,0.4)"],
    ];

    getDonotOptions = ({ reach_percent, mention_percent, engagement_percent, color }) => {
        let series = [
            {
                name: "Reach %",
                data: [{ y: reach_percent, color: color[0] }],
                radius: "100%",
                innerRadius: "80%",
                color: color[0],
                showInLegend: true,
            },
            {
                name: "Mentions %",
                data: [{ y: mention_percent, color: color[1] }],
                radius: "80%",
                innerRadius: "60%",
                color: color[1],
                showInLegend: true,
            },
            {
                name: "Engagement %",
                data: [{ y: engagement_percent, color: color[2] }],
                radius: "60%",
                innerRadius: "40%",
                color: color[2],
                showInLegend: true,
            },
        ];

        let self = this;

        let chartConfig = {
            chart: {
                type: "solidgauge",
                className: "skiptranslate",
                height: "255px",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            pane: {
                center: ["50%", "85%"],
                size: "150%",
                startAngle: -90,
                endAngle: 90,
                background: [
                    {
                        backgroundColor: "#EEE",
                        innerRadius: "80%",
                        outerRadius: "100%",
                        shape: "arc",
                    },
                    {
                        backgroundColor: "#EEE",
                        innerRadius: "60%",
                        outerRadius: "79%",
                        shape: "arc",
                    },
                    {
                        backgroundColor: "#EEE",
                        innerRadius: "40%",
                        outerRadius: "59%",
                        shape: "arc",
                    },
                ],
            },
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        enabled: false,
                    },
                },
            },
            yAxis: {
                min: 0,
                max: 100,
                lineWidth: 0,
                tickWidth: 0,
                minorTickInterval: null,
                tickAmount: 0,
                title: {
                    y: -70,
                },
                labels: {
                    y: 16,
                    format: "{text} %",
                },
            },
            legend: {
                alignColumns: false,
                // useHTML: true,
                align: "left",
                width: "100%",
                itemDistance: 5,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series,
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
            },
        };

        return chartConfig;
    };

    getLineOptions = (d, color) => {
        let data = d.mentionsChartData;

        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        const chartConfig = {
            chart: {
                type: "spline",
                height: "200px",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                lineColor: "#ccd6eb",
                lineWidth: 1,
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: 2,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: "Mentions",
            },
            series: [{ name: "Mentions", data, color: color[0] }],
            plotOptions: {
                spline: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                formatter: function () {
                    return `${moment(this.x).tz(tz).format("LLLL")}<br/>Mentions: <b>${numberWithCommas(this.y)}</b>`;
                },
                backgroundColor: "#fff",
                borderRadius: 6,
                outside: true,
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return chartConfig;
    };

    getCharts = () => {
        let { reach_sum, mentions_sum, engagement_sum, data, groupByTopics } = this.props.data.data;
        const sortedData = this.props.data.data.data.sort((a, b) => -1 * (a[this.props.sortBy] - b[this.props.sortBy]));
        const topData = sortedData.slice(0, 15);
        return topData.map((d, i) => {
            let subtopic_name = d.name;
            let topic_name;
            if (this.props.groupByTopics) topic_name = d.topic_name;
            else topic_name = d.topic_name;
            let reach_percent = Math.round((d.total_reach / reach_sum) * 100) ? Math.round((d.total_reach / reach_sum) * 100) : 0;
            let mention_percent = Math.round((d.total_mentions / mentions_sum) * 100) ? Math.round((d.total_mentions / mentions_sum) * 100) : 0;
            let engagement_percent = Math.round((d.total_engagement / engagement_sum) * 100) ? Math.round((d.total_engagement / engagement_sum) * 100) : 0;
            let color = this.colors[i % 7];
            return (
                <div key={d.id} className="leaderboard-chart-item">
                    <div className="name">{`${i + 1}. ${groupByTopics ? "" : subtopic_name} - (${topic_name})`}</div>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getDonotOptions({ reach_percent, mention_percent, engagement_percent, i, color })}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                    />
                    <div className="engagement-aggregation">
                        <div className="engagement-aggregation-item" style={{ borderColor: color[0] }}>
                            <div className="engagement-aggregation-item-value">{d.total_reach ? formatNumber(d.total_reach) : "0"}</div>
                            <div className="engagement-aggregation-item-label">Total Reach</div>
                        </div>
                        <div className="engagement-aggregation-item">
                            <div className="engagement-aggregation-item-value">{d.avg_reach ? formatNumber(d.avg_reach) : "0"}</div>
                            <div className="engagement-aggregation-item-label">Avg Reach</div>
                        </div>
                        <div className="engagement-aggregation-item" style={{ borderColor: color[1] }}>
                            <div className="engagement-aggregation-item-value">{d.total_mentions ? formatNumber(d.total_mentions) : "0"}</div>
                            <div className="engagement-aggregation-item-label">Total Mentions</div>
                        </div>
                        <div className="engagement-aggregation-item">
                            <div className="engagement-aggregation-item-value">{d.avg_mentions ? formatNumber(d.avg_mentions) : "0"}</div>
                            <div className="engagement-aggregation-item-label">Avg Mentions</div>
                        </div>
                    </div>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getLineOptions(d, color)}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                    />
                    <div className="engagement-aggregation">
                        <div className="engagement-aggregation-item" style={{ borderColor: color[2] }}>
                            <div className="engagement-aggregation-item-value">{d.total_engagement ? formatNumber(d.total_engagement) : "0"}</div>
                            <div className="engagement-aggregation-item-label">Total Engagement</div>
                        </div>
                        <div className="engagement-aggregation-item">
                            <div className="engagement-aggregation-item-value">{d.avg_engagement ? formatNumber(d.avg_engagement) : "0"}</div>
                            <div className="engagement-aggregation-item-label">Avg Engagement</div>
                        </div>
                    </div>
                    <div className="engagement-breakdown-columns">
                        <div className="engagement-breakdown">
                            <div className="engagement-breakdown-item">
                                <img width="20" src="icons/like.png" />
                                <span className="engagement-breakdown-item-value">{d.like_count ? formatNumber(d.like_count) : "0"}</span>
                            </div>
                            <div className="engagement-breakdown-item">
                                <img width="20" src="icons/comment.png" />
                                <span className="engagement-breakdown-item-value">{d.comment_count ? formatNumber(d.comment_count) : "0"}</span>
                            </div>
                            <div className="engagement-breakdown-item">
                                <img width="20" src="icons/share.png" />
                                <span className="engagement-breakdown-item-value">{d.share_count ? formatNumber(d.share_count) : "0"}</span>
                            </div>
                            <div className="engagement-breakdown-item">
                                <img width="20" src="icons/view.png" />
                                <span className="engagement-breakdown-item-value">{d.view_count ? formatNumber(d.view_count) : "0"}</span>
                            </div>
                        </div>
                        <div className="engagement-breakdown">
                            <div className="engagement-breakdown-item avg-impact-score">
                                <img height="30" src="icons/impact.png" />
                                <div className="engagement-breakdown-item-label">
                                    <p className="engagement-breakdown-item-value">{d.avg_impact_score ? Math.round(d.avg_impact_score * 100) / 100 : "0"}</p>
                                    <p>Avg Impact Score</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };

    render() {
        return this.getCharts();
    }
}

export default LeaderboardHealthCharts;
